var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    className: "feather feather-quote",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1166 14.9471C10.6628 17.2999 8.6034 19 6.20715 19H5.49184C1.9261 19 -0.493602 15.3744 0.874529 12.0816L4.78947 2.65906C5.45836 1.04916 7.03038 0 8.77371 0C11.4843 0 13.5235 2.47014 13.0101 5.13168L11.1166 14.9471ZM27.1166 14.9471C26.6628 17.2999 24.6034 19 22.2071 19H21.5623C17.9966 19 15.5769 15.3744 16.945 12.0816L20.8696 2.63594C21.5326 1.04004 23.091 0 24.8192 0C27.5062 0 29.5276 2.44866 29.0187 5.08706L27.1166 14.9471Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.53f77f1e.svg";
export { ForwardRef as ReactComponent };